
const InformationContentType = Symbol();

export class InformationContent {
    [InformationContentType]: any;
    readonly value: string;

    private constructor(informationContent: string) {
        this.value = informationContent;
    }

    static isInvalidSize(title: string): boolean {
        return title.length < 1 || title.length > 1000;
    }

    static messageInvalidSize(label: string): string {
        return `${label}は1文字以上1000文字以下で入力してください。`;
    }

    static fromString(informationContent: string): InformationContent {
        return new InformationContent(informationContent);
    }
}
